import { Sparkles } from "lucide-react";

export default function AiOrb({ label }) {
  const openChat = () => window.dispatchEvent(new CustomEvent("vvvoraa:open-chat"));

  return (
    <button
      type="button"
      onClick={openChat}
      className="ai-orb group relative flex items-center gap-2.5 rounded-full border border-[#4F8CFF]/30 bg-[#4F8CFF]/8 py-1.5 pl-1.5 pr-4 transition-all duration-300 hover:border-[#4F8CFF]/60 hover:bg-[#4F8CFF]/15 hover:shadow-[0_0_28px_-6px_rgba(79,140,255,0.7)]"
      data-testid="nav-ai-orb"
      aria-label={label || "Ask our AI"}
    >
      <span className="relative flex h-8 w-8 items-center justify-center">
        <span className="ai-orb-ring absolute inset-0 rounded-full" aria-hidden />
        <span className="ai-orb-core absolute inset-[5px] rounded-full" aria-hidden />
        <Sparkles className="relative h-3.5 w-3.5 text-white drop-shadow-[0_0_6px_rgba(255,255,255,0.9)]" />
      </span>
      {label && <span className="text-sm font-medium text-[#bcd4ff] group-hover:text-white transition-colors">{label}</span>}
    </button>
  );
}
